import styled from 'styled-components'

export const CostsComponent = styled.div`
  .profile_label {
    text-decoration: underline;
  }
  .profile_value {
    margin-left: 20px;
  }

  .copy {
    white-space: pre-wrap;
  }

  .profileContainer {
    p + p {
      margin-top: -5px;
    }
  }

  .investmentCostContainer {
    margin-top: 10px;
  }
`
